import React from 'react';
// import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../src/App.css'; 
import MissionHeroImg from '../assets/mission.png';

const Mission = () => {
  return (
    <>
      {/* Banner */}
      <section className="banner">
        <img id="banner-img" src={MissionHeroImg} alt="Our Mission & Values" />
      </section>

      {/* Main Content */}
      <div className="container py-5">
        {/* Mission & Vision Section */}
        <section className="row mb-5">
          <div className="col-lg-10 mx-auto">
            <div className="text-center mb-5 fade-up">
              <h1 className="display-5 fw-bold mb-3">Our Mission &amp; Vision</h1>
              <p className="lead text-muted">
                Guiding principles that drive everything we do
              </p>
            </div>

            <div className="row mb-5">
              {/* Mission Statement */}
              <div className="col-lg-6 mb-4 mb-lg-0 fade-up">
                <div className="p-5 rounded-4 h-100 bg-light">
                  <div className="text-center mb-4">
                    <h2 className="h3 text-dark fw-bold">Our Mission</h2>
                  </div>
                  <p className="fs-5 text-center mb-0">
                    Speech Innovation NC's mission is to promote an individual's
                    independence by improving their communication skills. We
                    accomplish this through education, advocacy, and evidence-based
                    practices.
                  </p>
                </div>
              </div>

              {/* Vision Statement */}
              <div className="col-lg-6 fade-up">
                <div className="p-5 rounded-4 h-100 bg-light">
                  <div className="text-center mb-4">
                    <h2 className="h3 text-dark fw-bold">Our Vision</h2>
                  </div>
                  <p className="fs-5 text-center mb-0">
                    To be our community's center of excellence in providing services
                    that enrich lives.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Core Values Section */}
        <section className="row mb-5">
          <div className="col-12">
            <div className="text-center mb-5 fade-up">
              <h2 className="h3 mb-3">Our Core Values</h2>
              <p className="lead text-muted">
                The principles that guide our daily practice
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  title: 'Compassion',
                  text: 'We approach every client with empathy, understanding, and genuine care for their unique journey.'
                },
                {
                  title: 'Excellence',
                  text: 'We commit to evidence-based practices and continuous learning to provide the highest quality care.'
                },
                {
                  title: 'Empowerment',
                  text: 'We believe in empowering individuals and families with tools and knowledge for lasting success.'
                },
                {
                  title: 'Inclusion',
                  text: 'We celebrate diversity and provide culturally sensitive, bilingual services to our community.'
                }
              ].map((value, idx) => (
                <div className="col-md-6 col-lg-3 fade-up" key={idx}>
                  <div className="card border-0 shadow-sm h-100">
                    <div className="card-body text-center p-4">
                      <h5 className="card-title fw-bold">{value.title}</h5>
                      <p className="card-text text-muted">{value.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Commitment Section */}
        <section className="row mb-5">
          <div className="col-lg-10 mx-auto">
            <div className="p-5 rounded-4 fade-up bg-light">
              <div className="text-center mb-4">
                <h2 className="h3 mb-3">Our Commitment to You</h2>
                <p className="lead text-muted">
                  What you can expect when you choose Speech Innovation NC
                </p>
              </div>

              <div className="row g-4">
                {[
                  {
                    title: 'Personalized Care Plans',
                    text: 'Every treatment plan is tailored to your specific needs, goals, and lifestyle.'
                  },
                  {
                    title: 'Family Involvement',
                    text: 'We actively involve families in the therapy process for better outcomes.'
                  },
                  {
                    title: 'Progress Tracking',
                    text: 'Regular assessments and clear communication about your progress.'
                  },
                  {
                    title: 'Comfortable Environment',
                    text: 'A warm, welcoming space where you feel safe and supported.'
                  }
                ].map((item, idx) => (
                  <div className="col-md-6" key={idx}>
                    <div className="d-flex">
                      <div>
                        <h5 className="fw-bold mb-1">{item.title}</h5>
                        <p className="text-muted mb-0">{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Impact Statement */}
        <section className="row mb-5">
          <div className="col-lg-8 mx-auto text-center fade-up">
            <div className="bg-light p-5 rounded-4">
              <h2 className="h3 mb-3">Making a Difference Since 2011</h2>
              <p className="fs-5 mb-4">
                For over a decade, we've been privileged to be part of countless
                communication success stories. Every breakthrough, every milestone,
                and every moment of progress reinforces our commitment to excellence
                and compassionate care.
              </p>
              <p className="text-muted">
                <em>
                  "Independence through communication is not just our mission—it's
                  our promise to every individual we serve."
                </em>
              </p>

            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Mission;
